import actionTypes from '../constants/action-types';

const setVariables = (variables) => ({
  type: actionTypes.SET_VARIABLES,
  payload: {
    variables,
  },
});

export default setVariables;
